<template>
	<div class="border-bottom bg-white mb-3">
		<div class="container p-3">
			<h5 class="mb-0">Настройки</h5>
		</div>
	</div>
	<div class="container">
		<div class="row">
			<div class="col-12">
				
				<div class="card mb-4">
					<div class="card-body">
						<div class="row align-items-center">
							<label class="col-sm-2 col-form-label fw-bold">Экспорт данных</label>
							<div class="col-sm-10">
								<div class="btn btn-lg btn-primary" @click="onExportBackup()">Скачать</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="card mb-4">
					<div class="card-body">
						<div class="row align-items-center">
							<label class="col-sm-2 col-form-label fw-bold">Импорт данных</label>
							<div class="col-sm-10">
								<input type="file" class="form-control" ref="fileBackupImport" accept="application/json" @change="onBackupFileSelected" />
							</div>
						</div>
					</div>
				</div>
				
				<div class="card mb-4">
					<div class="card-body">
						<div class="row align-items-center">
							<label class="col-sm-2 col-form-label fw-bold">Полный сброс данных</label>
							<div class="col-sm-10">
								<div class="btn btn-lg btn-danger" @click="onClear()">Сброс</div>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
import lib from '@/lib';

export default {
	name: "Settings",
	mixins: lib.mixins,
	methods: {
		onExportBackup(){
			const data = JSON.stringify({
				app: 'shoppinglist',
				version: 1,
				groups: this.appModel.groups,
			});
			const blob = new Blob([data], {type: 'text/plain'})
			const e = document.createEvent('MouseEvents'),
			a = document.createElement('a');
			a.download = "shoppinglist_backup_"+lib.formatDate(new Date(), 'YYYYMMDDHHmmss')+".json";
			a.href = window.URL.createObjectURL(blob);
			a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
			e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
			a.dispatchEvent(e);
		},
		onBackupFileSelected(e){
			let files = e.target.files;
			if(files.length){
				let extension = files[0].name.split('.').pop().toLowerCase();
				if(extension == 'json'){
					let reader = new FileReader();
					reader.onload = (e) => {
						let data = JSON.parse(e.target.result) || {};
						if((data.app || '') == 'shoppinglist'){
							if((data.version || 'unknown') == 1){
								this.appModel.groups = data.groups || [];
								this.appModel.doDataSave();
								alert('Данные успешно импортированы');
							} else {
								alert('Версия данной резервной копии не поддерживается');
							}
						} else {
							alert('Данный файл не является резервной копией этого приложения');
						}
						this.$refs.fileBackupImport.value = null;
					}
					reader.readAsText(files[0]);
				} else {
					alert('Данный файл не является резервной копией этого приложения');
					this.$refs.fileBackupImport.value = null;
				}
			}
		},
		onClear(){
			if(confirm('Вы уверены?')){
				this.appModel.doDataClear();
				alert('Данные успешно сброшены');
			}
		},
	},
};
</script>
